import React, { useState } from "react";
import ReReSubject from "./ReReSubject";

function RedoSubject(props) {
  const {
    formik,
    setParentSubjectRedoLength,
    parentSubjectRedoLength,
    reRegSubject,
  } = props;

  const [fields, setFields] = useState([{ subject: "" }]);

  function handleAdd() {
    const values = [...fields];
    values.push({ subject: "" });
    setFields(values);
    props.setParentSubjectRedoLength(values);
  }

  function handleRemove(i) {
    const values = [...fields];
    values.splice(i, 1);
    setFields(values);
    props.setParentSubjectRedoLength(values);
  }

  function handleSubjectChange(i, event) {
    const values = [...fields];
    values[i].subject = event.target.value;
    setFields(values);
    props.setParentSubjectRedoLength(values);
  }

  return (
    <>
      {formik.values.subjectRedo_.map((item, idx) => (
        <React.Fragment>
          <div className="row">
            <div className="col-sm-6">
              <select
                className="form-control"
                name={`subjectRedo_[${idx}].subject`}
                onChange={(e) => handleSubjectChange(idx, e)}
                onBlur={formik.handleBlur}
                key={idx}
                value={formik.values.subjectRedo_[idx].subject}
                disabled="disabled"
              >
                <option value="">---</option>
                <ReReSubject reRegSubject={reRegSubject} />
              </select>

              {formik.touched.subjectRedo_ &&
              formik.errors.subjectRedo_ &&
              formik.touched.subjectRedo_[idx] &&
              formik.errors.subjectRedo_[idx] &&
              formik.touched.subjectRedo_[idx].subject &&
              formik.errors.subjectRedo_[idx].subject ? (
                <div className="invalid-feedback" style={{ display: "block" }}>
                  {formik.errors.subjectRedo_[idx].subject}
                </div>
              ) : null}
            </div>
            {/* <div className="col pl-0">
              <a
                href
                className="btn btn-danger"
                onClick={() => handleRemove(idx)}
              >
                <i className="fal fa-trash-alt"></i>
              </a>
            </div> */}
          </div>
        </React.Fragment>
      ))}
      {/* <React.Fragment>
        <div className="form-group m-0">
          <a
            href
            className="btn btn-link p-0 btn-additional"
            onClick={() => handleAdd()}
          >
            <i className="fal fa-plus"></i> Add additional line item
          </a>
        </div>
      </React.Fragment> */}
    </>
  );
}

export default RedoSubject;
